<template>
	<v-app id="login-view" fluid tag="section">
		<v-app-bar color="secondary" dark dense style="max-height: 48px">
			<v-toolbar-title>
				<a href="/">
					<img src="/logo-wide.png" style="float: right;max-width: 100px;max-height: 40px;" />
				</a>
				<strong class="mr-1 font-weight-black">عضویت در </strong>
				&nbsp;
				<span class="warning--text">{{ longTitle }}</span>
			</v-toolbar-title>
		</v-app-bar>
		<v-container>
			<v-row align="center" justify="center">
				<v-col cols="10" md="6" xl="4" v-if="validParameters">
					<v-card ref="card" class="mx-auto my-12">
						<v-slide-x-transition :hide-on-leave="true">
							<div v-show="step === 'register'">
								<v-img class="white--text align-end" height="200px" src="/login-banner.jpg">
								</v-img>
								<v-card-title>جهت ثبت درخواست وام ابتدا باید ثبت نام خود را تکمیل نمایید</v-card-title>
								<v-form ref="formRegister" class="mx-2" lazy-validation @submit.prevent="handleRegister">
									<v-row class="pt-4">
										<v-col cols="12" md="6" class="py-0 mx-0">
											<v-text-field class="mx-0" v-model="user.firstName" label="نام*" :error-messages="errorMessages" :rules="[(val) => !!val || 'نام را وارد کنید']" focused />
										</v-col>
										<v-col cols="12" md="6" class="py-0 mx-0">
											<v-text-field class="mx-0" v-model="user.lastName" label="نام خانوادگی*" :error-messages="errorMessages" :rules="[(val) => !!val || 'نام خانوادگی را وارد کنید']" />
										</v-col>
										<v-col cols="12" md="6" class="py-0 mx-0">
											<v-text-field class="left-input mx-0" v-model="user.nationalCode" label="کد ملی*" maxlength="10" :error-messages="errorMessages" :rules="[(val) => !!val || 'کد ملی را وارد کنید', (val) => checkCodeMeli(val) || 'کد ملی وارد شده معتبر نمی باشد']" />
										</v-col>
										<v-col cols="12" md="6" class="py-0 mx-0">
											<v-text-field class="left-input mx-0" v-model="username" :hint="`نام کاربری با کدملی پر می شود. ${this.customerCode && this.customerCode != 0 ? 'دقت شود نام کاربری دارای کد پیشوند ' + this.customerCode + ' می باشد.' : ''}`" persistent-hint :disabled="true" label="نام کاربری" maxlength="10" />
										</v-col>
										<v-col cols="12" md="6" class="py-0 mx-0">
											<v-text-field class="left-input mx-0" v-model="user.password" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :rules="[() => !!user.password || 'کلمه عبور را وارد کنید', (val) => checkPasswordPolicy() || 'کلمه عبور نباید کمتر از 8 کاراکتر باشد']" :error-messages="errorMessages" :type="show1 ? 'text' : 'password'" name="password" label="کلمه عبور*" @click:append="show1 = !show1" />
										</v-col>
										<v-col cols="12" md="6" class="py-0 mx-0">
											<v-text-field class="left-input mx-0" v-model="user.confirmPassword" :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'" :rules="[() => user.confirmPassword === user.password || 'تکرار کلمه عبور با کلمه عبور مطابقت ندارد']" :error-messages="errorMessages" :type="show2 ? 'text' : 'password'" name="confirmPassword" label="تکرار کلمه عبور*" @click:append="show2 = !show2" />
										</v-col>
										<v-col cols="12" md="6" class="py-0 mx-0">
											<v-text-field class="left-input mx-0" v-model="user.mobile" label="شماره موبایل*" maxlength="11" hint="کد تائیدیه به این شماره ارسال می شود" :error-messages="errorMessages" :rules="[(value) => !!value || 'موبایل را وارد کنید', (value) => isPhoneNumberValid() || 'موبایل را به صورت صحیح وارد کنید']" required />
											<!-- <v-text-field maxlength="11" dark v-model="user.mobile" label="شماره موبایل" hint="شماره موبایل به صورت صحیح وارد شود. کد به این شماره ارسال می شود" :error-messages="errorMessages" :rules="[(value) => !!value || 'موبایل را وارد کنید', (value) => isPhoneNumberValid() || 'موبایل را به صورت صحیح وارد کنید']" required /> -->
										</v-col>
									</v-row>
									<v-row class="mx-0">
										<v-col cols="4" class="px-0">
											<v-text-field label="کد امنیتی" maxLength="4" v-model="registerCaptcha">
											</v-text-field>
										</v-col>
										<v-col cols="8" sm="5" md="5" class="" style="direction: ltr;display: flex;align-items: center;justify-content: end;">
											<v-btn class="mr-1" color="secondary" small fab icon @click="refreshRegisterCaptcha()"><v-icon>mdi-refresh</v-icon></v-btn>
											<CaptchaImage ref="registerCaptcha" :codeType="['0']" style="direction: ltr;" />
										</v-col>
									</v-row>
									<div class="form-group">
										<v-alert v-if="message" type="error" outlined>
											{{ message }}
										</v-alert>
									</div>
									<v-card-actions>
										<v-spacer />
										<v-btn ref="submit" color="secondary" dark :loading="loading" type="submit">
											ثبت نام
										</v-btn>
										<v-spacer />
									</v-card-actions>
									<div class="text-center my-3">
										<v-btn class="mx-auto mb-2" text @click="goLoginPage">قبلا ثبت نام کرده اید؟ ورود</v-btn>
									</div>
								</v-form>
							</div>
						</v-slide-x-transition>
					</v-card>
					<v-card ref="card" class="mx-auto my-12">
						<v-slide-x-transition :hide-on-leave="true">
							<div v-show="step === 'smsCode'">
								<div class="pa-5 text-center grey--text">لطفا جهت تکمیل ثبت نام، کد تائیدیه ارسال شده به شماره <span class="secondary--text mx-1">{{ user.mobile }}</span> را ثبت کنید</div>
								<v-form ref="formSmsCode" class="mx-2" lazy-validation>
									<v-row>
										<v-col cols="12" class="mt-4">
											<div class="d-flex justify-center flex-row-reverse">
												<v-text-field class="code-inputs" outlined v-model="smsCode.activationCode[0]" maxLength="1" type="tel" tabindex="1" @input="focusOnNext()" autofocus />
												<v-text-field class="code-inputs" outlined v-model="smsCode.activationCode[1]" maxLength="1" type="tel" tabindex="2" @input="focusOnNext()" />
												<v-text-field class="code-inputs" outlined v-model="smsCode.activationCode[2]" maxLength="1" type="tel" tabindex="3" @input="focusOnNext()" />
												<v-text-field class="code-inputs" outlined v-model="smsCode.activationCode[3]" maxLength="1" type="tel" tabindex="4" @input="focusOnNext()" />
												<v-text-field class="code-inputs" outlined v-model="smsCode.activationCode[4]" maxLength="1" type="tel" tabindex="5" @input="focusOnNext()" @keyup.enter="handleSmsCode" />
											</div>
										</v-col>
									</v-row>
									<v-card-actions>
										<v-spacer />
										<v-btn color="secondary" dark :loading="loading" @click="handleSmsCode">
											ثبت کد
										</v-btn>
										<v-spacer />
									</v-card-actions>
									<div class="form-group">
										<v-alert type="error" v-if="smsCodeMessage" outlined>
											{{ smsCodeMessage }}
										</v-alert>
									</div>
									<div class="text-center my-3">
										<v-btn class="mx-auto mb-2" text @click="step = 'register'">بازگشت به ثبت نام</v-btn>
									</div>
								</v-form>
							</div>
						</v-slide-x-transition>
					</v-card>
					<v-card ref="card" class="mx-auto my-12">
						<v-slide-x-transition :hide-on-leave="true">
							<div v-show="step === 'verifySuccess'">
								<div class="d-flex flex-column justify-center align-center" style="height:200px;background-color: rgb(182 255 193);">
									<v-icon size="100" color="success">
										mdi-check-circle
									</v-icon>
								</div>
								<p class="success--text py-3 text-center">تائید کد با موفقیت انجام شد.</p>
								<div class="text-center">تا لحظاتی دیگر به پنل کاربری هدایت می شوید...</div>
								<div class="form-group">
									<v-alert type="error" v-if="redirectToPanelMessage" outlined>
										{{ redirectToPanelMessage }}
									</v-alert>
								</div>
								<div class="text-center my-3">
									<v-btn class="mx-auto mb-2" color="secondary" @click="goLoginPage" :loading="redirectToPanelLoading">ورود به پنل کاربری</v-btn>
								</div>
							</div>
						</v-slide-x-transition>
					</v-card>
				</v-col>
				<v-col cols="10" md="6" xl="4" v-else>
					<v-card ref="card" class="mx-auto my-12">
						<v-slide-x-transition :hide-on-leave="true">
							<div>
								<v-img class="white--text align-end" height="200px" src="/login-banner.jpg">
									<v-card-title>جهت ثبت درخواست وام ابتدا باید ثبت نام خود را تکمیل نمایید</v-card-title>
								</v-img>
								<v-alert type="error" outlined>
									اطلاعات پارامترهای مشتری معتبر نمی باشد
								</v-alert>
							</div>
						</v-slide-x-transition>
					</v-card>

				</v-col>
			</v-row>
		</v-container>
	</v-app>
</template>

<script>
	import api from '@/util/app-api'
	import CaptchaImage from '@/components/app/CaptchaImage.vue'
	import { get } from 'vuex-pathify'
	import { setCookie, getCookie } from '@/util/helpers'
	import router from '../router'
	import ThemeManager from '@/util/theme-manager.js'

	export default {
		name: 'Register',
		components: {
			CaptchaImage: CaptchaImage
		},
		data() {
			return {
				registerCaptcha: '',
				smsCodeCaptcha: '',
				step: 'register',
				smsCode: { activationCode: [null, null, null, null, null, null], userId: 0, code: '' },
				user: { firstName: '', lastName: '', nationalCode: '', mobile: '', password: '', confirmPassword: '' },
				loading: false,
				redirectToPanelLoading: false,
				message: '',
				smsCodeMessage: '',
				errorMessages: '',
				redirectToPanelMessage: '',
				show1: false,
				show2: false,
				customerCode: '',
				validParameters: true,
				usernameLocal: ''
			}
		},
		computed: {
			...get('siteConfig', [
				'isCloud', 'longTitle'
			]),
			loggedIn() {
				return this.$store.state.auth.status.loggedIn
			},
			username: {
				get() {
					return `${this.isCloud && this.customerCode && this.user.nationalCode ? this.customerCode + '-' : ''}${this.user.nationalCode}`
				},
				set(val) {
					this.usernameLocal = val
				},
			}
		},
		created() {
			ThemeManager.ApplyThemeSettings(this.$route.params.customerCode || 0, this.$vuetify)
		},
		mounted() {
			this.customerCode = this.$route.params.customerCode || 0
			if ((!this.customerCode || isNaN(this.customerCode)) && this.isCloud)
				this.validParameters = false

			this.manageAffiliate()
			this.manageAgentCode()
		},
		methods: {
			manageAffiliate() {
				let mrk = this.$route.query.mrk
				if (!mrk)
					return

				setCookie('mrk', mrk, 180)

				let customerCode = this.$route.params.customerCode || 0
				api.post(`Visitor/LogVisitor/?customerCode=${customerCode}&mrkCode=${mrk}`, {}, { authHeader: false, contentType: 'application/json' })
					.then(response => {
					})
					.catch(err => {
					})
			},
			manageAgentCode() {
				let agn = this.$route.query.agn
				if (!agn)
					return

				setCookie('agn', agn, 180)
			},
			handleRegister() {
				if (!this.$refs.formRegister.validate()) {
					return
				}
				if (!this.$refs.registerCaptcha.verify(this.registerCaptcha)) {
					this.message = 'کد امنیتی صحیح نمی باشد.'
					return
				} else {
					this.message = ''
				}
				this.user.customerCode = this.customerCode
				const mrkCode = getCookie('mrk')
				if (mrkCode || mrkCode == 0)
					this.user.mrkCode = mrkCode

				const agnCode = getCookie('agn')
				if (agnCode && agnCode > 0)
					this.user.agnCode = agnCode

				this.loading = true
				api.post('account/preRegisterAndSendOTP/', this.user, { authHeader: false, contentType: 'application/json' })
					.then(response => {
						this.smsCode.userId = response.userId
						this.smsCodeMessage = ''
						if (response.isOtpActive) {
							this.step = 'smsCode'
						}
						else {
							this.step = 'verifySuccess'
							this.redirectToPanel()
						}

					})
					.catch(err => {
						this.message = err.message
					})
					.finally(() => {
						this.loading = false
					})
			},
			handleSmsCode() {
				if (!this.$refs.formSmsCode.validate()) { return }

				this.loading = true
				this.smsCode.code = this.smsCode.activationCode.join('')
				api.post('account/verifySmsCode/', this.smsCode, { authHeader: false, contentType: 'application/json' })
					.then(response => {
						this.step = 'verifySuccess'
						this.redirectToPanel()
					})
					.catch(err => {
						this.smsCodeMessage = err.message
					})
					.finally(() => {
						this.loading = false
					})
			},
			redirectToPanel() {
				this.redirectToPanelLoading = true
				setTimeout(() => {
					this.user.username = this.username
					this.$store.dispatch('auth/login', this.user).then((to) => {
						// router.replace('/member/LoanRequest/' + response).catch(() => { })
						this.$router.replace('/member/LoanRequest/').catch(() => { })
						this.redirectToPanelLoading = false
					}).catch(error => {
						this.redirectToPanelLoading = false
						this.redirectToPanelMessage = error.message || error.toString()
					})
				}, 2000)
			},
			refreshRegisterCaptcha() {
				this.$refs.registerCaptcha.refresh()
			},
			refreshSmsCodeCaptcha() {
				this.$refs.smsCodeCaptcha.refresh()
			},
			goLoginPage() {
				this.$router.replace('/login').catch(() => { })
			},
			checkCodeMeli(code) {

				var L = code.length

				if (L < 8 || parseInt(code, 10) == 0) return false
				code = ('0000' + code).substr(L + 4 - 10)
				if (parseInt(code.substr(3, 6), 10) == 0) return false
				var c = parseInt(code.substr(9, 1), 10)
				var s = 0
				for (var i = 0; i < 9; i++)
					s += parseInt(code.substr(i, 1), 10) * (10 - i)
				s = s % 11
				return (s < 2 && c == s) || (s >= 2 && c == (11 - s))
				return true
			},
			isPhoneNumberValid() {
				return this.user.mobile && (/^((?!(0))[0-9]{10})$/g.test(this.user.mobile) || /^0[0-9]\d{9}$/g.test(this.user.mobile))
			},
			checkPasswordPolicy() {
				if (!(this.user.password.length > 8))
					return false
				return true
			},
			focusOnNext() {
				var currInput = document.activeElement
				if (currInput?.tagName.toLowerCase() == "input") {
					var inputs = document.getElementsByTagName("input")
					var currInput = document.activeElement
					for (var i = 0; i < inputs.length; i++) {
						if (inputs[i] == currInput) {
							var next = inputs[i + 1]
							if (next && next.focus) {
								next.focus()
							}
							break
						}
					}
				}
			},
		},
	}
</script>

<style scoped lang="scss">
	.code-inputs {
		width: 55px;
		max-width: 55px;
		margin: 0 10px;
	}
</style>
